import { useEffect, useState } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import MenuAdmin from '../components/menus/MenuAdmin'
import Sidebar from '../components/menus/Sidebar'
import TopBar from '../components/menus/TopBar'
import Dashboard from '../pages/admin/Dashboard'
import { useAuth } from '../components/auth/useAuth'
import NothingHere from '../pages/error/NothingHere'
import Users from '../pages/admin/Users'
import Policies from '../pages/Policies'
import PolicyDetail from '../pages/PolicyDetail'
import Sinesters from '../pages/Sinesters'
import SinesterDetail from '../pages/SinesterDetail'
import Receipts from '../pages/Receipts'
import ReceiptDetail from '../pages/ReceiptDetail'
import Clients from '../pages/Clients'
import ClientDetail from '../pages/ClientDetail'
import DocumentManagement from '../pages/admin/DocumentManagement'
import CompanyManagement from '../pages/admin/CompanyManagement'
import SucursalManagement from '../pages/admin/SucursalManagement'
import CategoryManagement from '../pages/admin/CategoryManagement'
import SinesterTypeManagement from '../pages/admin/SinesterTypeManagement'
import PaymentMethodsManagement from '../pages/admin/ReceiptPaymentMethod'
import InvolvedTypeManagement from '../pages/admin/InvolvedTypeManagement'



export default function AdminRouter() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { clientauth } = useAuth()

	const [isCollapsed, setIsCollapsed] = useState(false)
	const toggleSidebar = () => {
		setIsCollapsed(!isCollapsed)
	}

	useEffect(() => {
		let token = localStorage.getItem('jwt')

		if (!token) {
			navigate(`/${t("url.auth.login")}`)
		}
	}, [navigate, t])

	const adminRoutesAlias = {
		"": "dashboard",
		[t("url.dashboard")]: "dashboard",
		[t("url.users")]: "users",
		[t("url.clients")]: "clients",
		[`${t("url.clients")}/:id`]: "clientDetail",
		[t("url.policies")]: "policies",
		[`${t("url.policies")}/:id`]: "policyDetail",
		[t("url.sinesters")]: "sinesters",
		[`${t("url.sinesters")}/:id`]: "sinesterDetail",
		[t("url.receipts")]: "receipts",
		[`${t("url.receipts")}/:id`]: "receiptDetail",
		[t("url.documentsManagement")]: "documentsManagement",
		[t("url.sucursalsManagement")]: "sucursalsManagement",
		[t("url.companiesManagement")]: "companiesManagement",
		[t("url.categoriesManagement")]: "categoriesManagement",
		[t("url.sinestersTypesManagement")]: "sinestersTypesManagement",
		[t("url.paymentMethodsManagement")]: "paymentMethodsManagement",
		[t("url.involvedTypesManagement")]: "involvedTypesManagement"
	}

	const getComponentAdmin = (path: string) => {
		switch (path) {
			case "dashboard": return <Dashboard />;
			case "users": return <Users />;
			case "clients": return <Clients />;
			case "clientDetail": return <ClientDetail />;
			case "policies": return <Policies />;
			case "policyDetail": return <PolicyDetail />;
			case "sinesters": return <Sinesters />;
			case "sinesterDetail": return <SinesterDetail />;
			case "receipts": return <Receipts />;
			case "receiptDetail": return <ReceiptDetail />;
			case "documentsManagement": return <DocumentManagement />;
			case "companiesManagement": return <CompanyManagement />;
			case "sucursalsManagement": return <SucursalManagement />;
			case "categoriesManagement": return <CategoryManagement />;
			case "sinestersTypesManagement": return <SinesterTypeManagement />;
			case "paymentMethodsManagement": return <PaymentMethodsManagement />;
			case "involvedTypesManagement": return <InvolvedTypeManagement />;
			default: return <NothingHere />;
		}
	}

	return (
		<div className="app-shell">
			<TopBar rol={clientauth?.rol} />
			<div className="app-shell__body">
				<Sidebar rol={clientauth?.rol} />
				<div className="app-content py-4 py-lg-5">
					<MenuAdmin rol={clientauth?.rol} toggleSidebar={toggleSidebar} isCollapsed={isCollapsed} />
					<Routes>
						{Object.entries(adminRoutesAlias).map(([alias, path]) => (
							<Route key={alias} path={alias} element={getComponentAdmin(path)} />
						))}
						<Route path="*" element={<NothingHere />} />
					</Routes>
				</div>
			</div>
		</div>
	)
}